export default {
  benefits: {
    earn_points: 'Gagnez des points à chaque commande',
    get_deals: 'Recevez des remises exclusives',
    redeem_points: 'Échangez vos points contre des repas gratuits',
  },
};
